import styles from './Info.module.css';
import image1 from '../images/jo.webp';

const Info = () => {

  return (
    <div className={styles.infoContainer}>
      <h1 className={styles.title}>Josep Tarres Toneu</h1>
      <p className={styles.description}>Apasionat de la tecnologia i la programació, sempre busco nous reptes i oportunitats per aprendre i crèixer professionalment.</p>
      <p className={styles.description}>Decideixo fundar CodeLabOsona al 2024 amb l'objectiu per ajudar a transformar digitalment el sector d'atenció a les persones.</p>
      <p className={styles.description}>Amb una llarga experiència al sector de l'Atenció a les Persones m'he format en les dues meves passions: gestió d'organització i mòn digital.</p>
      <q className={styles.description}>Que algo no haya salido como hayas querido, no significa que sea inútil - Thomas Edison</q>
      <img src={image1} alt="Josep Tarres" className={styles.profileImage} />
    </div>
  );
};

export default Info;
